export const TRANSLATIONS_EN = {
  sidebar: {
    hello: 'Hello',
    infoTime: 'Time to complete the registration',
    oop: 'Onboarding Organisation Platform',
    business: {
      h2: 'Business Information',
      paragraph: 'Please review and complete the following details about the organisation you are onboarding.',
      dt1: 'Legal Organization Name and Category',
      dd1: 'This is the official name of the organization and category as registered in the country of operation. It has been pre-filled and cannot be edited.',
      dt2: 'City, Business Address, and Phone Number',
      dd2: 'Provide the city, full business address, and the main office phone number used in the country of operation.',
    },
    docs: {
      h2: 'Documentation requested by \n UNHAS',
      paragraph:
        'Following documents needs to be downloaded, duly completed, signed by the Country Director/Representative and uploaded in the form.',
      dt1: 'Organization Signatory Introduction Form (link)',
      dd1: 'Introduction form to be signed by the Country Director',
      dt2: 'Financial Conditions for the Provision of Air Transport Services (link)',
      dd2: 'Documentation needed to confirm the status of your financial conditions.',
      dt3: 'Other documents',
      dd3: 'The other documents needs to be uploaded if indicated in the registration form.',
    },
    focalPoints: {
      h2: 'Contact details for Head of Organization and Focal Points.',
      paragraph:
        'In this area you should provide contact details for Head of Organization and designated focal points, who will have access to specific areas on the UN Booking Hub.​',
      dt1: 'Head of Organisation/Representative',
      dd1: 'Provide contact details for Head of Organization/Representative in the country of operation.',
      dt2: 'Deputy Head of Organisation',
      dd2: 'Responsible for: organisation’s account updates, verifying if booked passengers are employees, at the time of first booking only',
      dt3: 'Booking Focal Point',
      dd3: 'Provide contact details for designated booking focal points, responsible\n' + 'for booking of passengers.',
    },
    organisation: {
      h2: 'Select Organisation Category \n and Country',
      paragraph: 'Indicate which category best represents your \n organisation and the country in which you operate',
      dt1: 'Organisation category',
      dd1: 'Select the category that best describes your organisation',
      dt2: 'Select Country Operation',
      dd2: 'Select the country for which you are applying',
    },
    review: {
      h2: 'Final review',
      paragraph1: 'Review the entries before submitting the form.',
      h4: ' ',
      paragraph2: 'After submission, UNHAS team will review your request and inform about status of your application.',
    },
    submitted: {
      h2: 'Your application has been succesfully received.',
      paragraph1: 'An email containing all the information for the next steps has been sent to ',
      paragraph2: 'UNHAS team will review your request and inform about status of your application.',
    },
    welcome: {
      h2: 'Welcome to the Organisation Onboarding Platform',
      paragraph_1:
        'This platform is your starting point to register your organisation and gain access to UNHAS services.\n Please ensure all required information is ready before you begin',
      paragraph_2:
        'The process takes approximately 15 minutes and must be completed in one session — progress cannot be saved. For assistance, please contact UNHAS Support\n',
    },
    signUp: {
      intro: '24/7 inter-agency booking services supporting humanitarian workers to deliver last mile aid',
      title: 'Register your account',
      description:
        '<0>You have been invited to register by the UNHAS team. Registration will allow you to start onboarding your organization in the country where you operate, in order to take advantage of the United Nations Humanitarian Air Service.</0><1>Remember that, once logged in, the process will take not more than 15 mins. Also, please, be sure that you have all the requested documents to complete the onboarding process at once. Will not be possible save and continue later.</1>',
    },
    signIn: {
      intro: '24/7 inter-agency booking services supporting humanitarian workers to deliver last mile aid',
      title: 'Log in into your account',
      description:
        '<0>Log in now to start onboarding your organization in the country where you operate, in order to take advantage of the United Nations Humanitarian Air Service.</0><1>Remember that, once logged in, the process will take not more than 15 mins. Also, please, be sure that you have all the requested documents to complete the onboarding process at once. Will not be possible save and continue later.</1>',
    },
  },
  content: {
    add: 'Add',
    remove: 'Remove',
    email: 'Email',
    middleName: 'Middle Name',
    name: 'Name',
    surname: 'Surname',
    title: 'Title/Designation',
    phoneNumber: 'Phone number',
    attachments: {
      maxSingleFileSize: 'Max single file size',
      maxTotalFileSize: 'Max total size',
      allowedExtensions: 'Allowed extensions'
    },
    business: {
      address: 'Business Address in the Country of the Operation',
      btnBack: 'Back to Organisation',
      btnSubmit: 'Go to Director and Focal Points',
      city: 'City',
      countryOperation: 'Country of the operation',
      legalOrganisationName: 'Organisation Legal Name',
      organisationCategory: 'Organisation Category',
      stepper: 'Business Information',
    },
    docs: {
      docType1: 'Organization Signatory Introduction Form*',
      docType2: 'UNHAS Financial Conditions for the Provision of Air Transport Services*',
      docType3: 'Extra: Clearance from the Governmental Institution*',
      docType4: 'Extra: Introductory Letter from OCHA*',
      btnBack: 'Back to Director and Focal Points',
      btnSubmit: 'Confirm request',
      stepper: 'Documentation requested by UNHAS',
    },
    focalPoints: {
      btnBack: 'Back to Business',
      btnSubmit: 'Go to Attachments',
      booking: 'Booking Focal Point',
      clearing: 'Deputy Head of Organisation',
      countryDirector: 'Head of Organization',
      inTotal: 'in total',
      registering: 'Registering Focal Point',
      stepper: 'Informations of Director and Focal Points',
      domainError: "Domain must match RFP domain",
    },
    organisation: {
      category: 'Organisation category',
      country: 'Country of the operation',
      h4: 'Please, remember to have the following informations to \n proceed with the request to onboard your organisation:',
      li1: 'Informations about organisation category, the country where you are \n operating',
      li2: 'Legal name, address of the organisation in the country where you are \n requesting the onboarding',
      li3: 'Informations about the Country Director, Registration, Clearing and \n Booking Focal Points',
      li4: 'Documentation requested by UNHAS',
      selectCategory: 'Select the category',
      selectCountry: 'Select the country',
      stepper: 'Select Organisation Category and Country',
      submit: 'Confirm and go to requesting module',
    },
    review: {
      btnBack: 'Go back to Edit',
      btnSubmit: 'Submit',
      business: 'Business',
      stepper: 'Submit your request if all is correct',
    },
    welcome: {
      h2: 'Before You Begin',
      h4: "To proceed with your organisation's onboarding request, please ensure you have the following information and documents ready:",
      li1: 'Organization’s legal name and contact details in the country of operation.',
      li2: 'Head of Organisation/Representative​ contact information',
      li3: 'Deputy Head of Organisation/Representative​ contact information',
      li4: 'Designated Booking Focal Points contact information',
      li5: 'Documentation specified in the registration form including',
      li5_1: "Duly completed and signed Organisation's Signatory Introductory Form",
      li5_2: 'Duly completed and signed Financial Conditions for Provisions of Air Transport Services',
      li5_3: 'Other documentation specified in the registration form',
      submit: 'Start now the onboarding process',
    },
    signUp: {
      firstName: { title: 'Name', placeholder: 'Your name' },
      middleName: { title: 'Middle Name', placeholder: 'Your Middle name' },
      lastName: { title: 'Surname', placeholder: 'Your surname' },
      email: { title: 'Email', placeholder: 'Insert the email you want to use' },
      agency: { title: 'Agency', placeholder: 'Insert the agency you belong to' },
      password: { title: 'Password', placeholder: 'Insert the password (At least 6 characters)' },
      confirmPassword: { title: 'Repeat Password', placeholder: 'Repeat the password' },
      title: 'Register now',
      secure: 'Prove you are human, resolve this simple equation:',
      submit: 'Create your account and start the registration',
      or: 'Or',
      logIn: 'Log In now',
    },
    signIn: {
      email: { title: 'Email', placeholder: 'Insert the email shared with UNHAS' },
      password: { title: 'Password', placeholder: 'Insert the password' },
      title: 'Log In',
      intro: 'Please, insert the email communicated to UNHAS and the password you set during the registration',
      forgotPassword: 'Forgot the password?',
      submit: 'Log In now',
      or: 'Or',
      signUp: 'Register now to the UN Booking Hub',
    },
  },
};
